import useSWR from "swr";
import { fetcherNoCreds } from "utils/fetcher";

export default () => {
  const { data: walletCount, isLoading: walletCountLoading } = useSWR(
    `${process.env.REACT_APP_AUTH_API_URL}/api/wallets/count`,
    fetcherNoCreds
  );

  return {
    walletCount: walletCount?.data,
    walletCountLoading,
  };
};
